import { useState, useCallback } from "react";
import { removeAccents } from "utils/string";

export function useSearchFilters({ isCustomer }) {
  const [search, setSearch] = useState("");

  const getFilters = useCallback(() => {
    if (!search) return {};

    const cleanSearch = search.trim();
    const searchWords = cleanSearch.split(/\s+/).filter((str) => str !== "");
    const searchComplete = cleanSearch;

    // Configuration des transformations par champ
    const fieldTransforms = {
      reference: null,
      "[entreprise_de_travaux][siret]": null,
      nom_offre: null,

      "[beneficiaire][slug]": removeAccents,
      "[beneficiaire][nom]": null,
      "[beneficiaire][prenom]": null,

      "[chantiers][slug]": removeAccents,
      "[chantiers][adresse]": null,
      "[chantiers][ville]": null,
      "[chantiers][code_postal]": null,
    };

    // Filtres de recherche
    const filters = [];

    // 1. Recherche par phrase complète
    Object.entries(fieldTransforms).forEach(([field, transform]) => {
      if (
        isCustomer &&
        (field === "reference" || field === "[entreprise_de_travaux][siret]")
      ) {
        return; // Ignorer ces champs pour les clients
      }

      // Applique la transformation avant de construire le filtre
      const value = transform ? transform(searchComplete) : searchComplete;

      filters.push({ [field]: { $containsi: value } });
    });

    // 2. Recherche par mots individuels (si 2+ mots)
    if (searchWords.length > 1) {
      // Pour chaque champ
      Object.entries(fieldTransforms).forEach(([field, transform]) => {
        if (
          isCustomer &&
          (field === "reference" || field === "[entreprise_de_travaux][siret]")
        ) {
          return; // Ignorer ces champs pour les clients
        }

        // Créer un $and pour tous les mots
        const wordFilters = {
          $and: searchWords.map((word) => {
            // Applique la transformation à chaque mot
            const value = transform ? transform(word) : word;
            return { [field]: { $containsi: value } };
          }),
        };

        filters.push(wordFilters);
      });
    }

    return { $or: filters };
  }, [isCustomer, search]);

  return {
    search,
    setSearch,
    getFilters,
  };
}
